import { StoreInfo } from '../../types';
import { mapTipHtml, type MapTipContent } from '../lib/mapTooltip';

/**
 * Groups stores by approximate coordinate hashes to handle overlapping markers.
 */
export const clusterStores = (stores: StoreInfo[]): Record<string, StoreInfo[]> => {
  const clusters: Record<string, StoreInfo[]> = {};
  
  stores.forEach(s => {
    if (!s.coordinates) return;
    
    const lat = Number(s.coordinates.lat);
    const lng = Number(s.coordinates.lng);
    
    if (isNaN(lat) || isNaN(lng)) return;
    
    // Using 4 decimal places for approximate grouping (~11m precision)
    const key = `${lat.toFixed(4)},${lng.toFixed(4)}`;
    if (!clusters[key]) clusters[key] = [];
    clusters[key].push(s);
  });
  
  return clusters;
};

/**
 * Tooltip HTML for a (possibly clustered) store marker, in the shared map
 * tooltip design. `extra` adds stats/badges (e.g. amount spent).
 */
export const getClusterTooltipHtml = (
  stores: StoreInfo[],
  primaryStore: StoreInfo,
  extra: Pick<MapTipContent, 'stats' | 'badge'> = {},
): string =>
  mapTipHtml({
    eyebrow: stores.length > 1 ? `${stores.length}×` : undefined,
    title: primaryStore.name || 'Unknown Store',
    subtitle: primaryStore.address || undefined,
    ...extra,
  });
